<template>
  <div class="large_main">
    <div class="top_title">
      <div class="title_text">电梯智慧云监控</div>
      <div class="time">{{ time }}</div>
    </div>
    <div class="large_content">
      <div class="left">
        <div class="baoyang_success item_box">
          <div class="item_title_box">今日班组保养完成率</div>
          <div class="baoyang_content tech-panel">
            <div class="baoyang_box">
              <div class="swiper-wrapper">
                <div
                  class="baoyang_list swiper-slide"
                  v-for="(item, index) in maintenanceUserList"
                  :key="index"
                >
                  <div class="list_item">
                    <div class="baoyang_title">
                      {{ item.unitName }}班（{{ item.areaName }}）
                      <div class="baoyang_tag">平均维保时长：{{ item.wbTimeNo }}</div>
                    </div>
                    <div class="baoyang_list_main">
                      <el-progress
                        :stroke-width="10"
                        type="circle"
                        color="#00CB61"
                        :width="70"
                        :percentage="
                          item.planNumber
                            ? ((item.planFinishNumber / item.planNumber) * 100).toFixed(2)
                            : 0
                        "
                        text-color="#fff"
                      ></el-progress>
                      <img class="icon" src="@/assets/other/dengyu.png" alt="" />
                      <div class="tips_box">
                        <div class="tips">
                          计划已完成:<span>{{ item.planFinishNumber }}</span>
                        </div>
                        <div class="line"></div>
                        <div class="tips">
                          计划保养单:<span>{{ item.planNumber }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                v-if="maintenanceUserList.length == 0"
                class="nothing"
                src="@/assets/image/nothing.png"
                alt="暂无数据"
              />
            </div>
          </div>
        </div>
        <div class="today_bao item_box">
          <div class="item_title_box">今日保养</div>
          <div class="baoyang_step_box tech-panel">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in upKeepDayDetailVo"
                :key="index"
              >
                <div class="today_content">
                  <el-form label-width="80px">
                    <el-row :span="24">
                      <el-col :span="12">
                        <el-form-item label="工单编号:">
                          {{ item.workOrder }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="工单状态:">
                          {{ getStatus(item.orderType) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="项目名称:">
                          {{ item.wbName }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="签到时间:">
                          {{ item.wbUserTime }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="维保班组:">
                          {{ item.unitName }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="保养时长:">
                          {{ item.wbTime }}
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <div class="step_box">
                    <div class="step_list one">
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/wbry.png" alt="" />
                        <div class="step_title">维保人员</div>
                        <div class="line"></div>
                      </div>
                      <div class="step_desc">{{ item.wbUserName }}</div>
                    </div>
                    <div class="step_list two">
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/byzp.png" alt="" />
                        <div class="step_title">保养照片</div>
                        <div class="line"></div>
                      </div>
                      <div class="step_desc">
                        <el-image
                          v-if="item.wbSignImg"
                          style="width: 60px; height: 60px"
                          :src="item.wbSignImg"
                          :preview-src-list="[item.onSitePhotos]"
                        />
                        <span style="color: #fff" v-else>暂无</span>
                      </div>
                    </div>
                    <div class="step_heng">
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/qianzi.png" alt="" />
                        <div class="step_title">维保签字</div>
                      </div>
                      <div class="step_desc">
                        <el-image
                          v-if="item.wbSignImg"
                          style="width: 48px; height: 48px"
                          :src="item.wbSignImg"
                          :preview-src-list="[item.wbSignImg]"
                        />
                        <span style="color: #fff" v-else>暂无</span>
                      </div>
                      <div class="line_box">
                        <div class="line"></div>
                      </div>
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/qianzi.png" alt="" />
                        <div class="step_title">物业签字</div>
                      </div>
                      <div class="step_desc">
                        <el-image
                          v-if="item.wbSignImg"
                          style="width: 48px; height: 48px"
                          :src="url"
                          :preview-src-list="[item.wySignImg]"
                        />
                        <span style="color: #fff" v-else>暂无</span>
                      </div>
                    </div>
                  </div>
                  <div class="location">
                    <img class="address_icon" src="@/assets/other/location_icon.png" />
                    {{ item.address }}
                  </div>
                </div>
              </div>
            </div>
            <img
              v-if="upKeepDayDetailVo.length == 0"
              class="nothing"
              src="@/assets/image/nothing.png"
              alt="暂无数据"
            />
          </div>
        </div>
      </div>
      <div class="center">
        <div class="center_top">
          <div class="all_baoyang">
            <el-progress
              :stroke-width="10"
              type="circle"
              color="#00CB61"
              :width="92"
              :percentage="
                formData.planNumber
                  ? ((formData.planFinishNumber / formData.planNumber) * 100).toFixed(2)
                  : 0
              "
              text-color="#fff"
            ></el-progress>
            <img class="icon" src="@/assets/other/by_line.png" alt="" />
            <div class="tips_box">
              <div class="tips">
                计划已完成:<span>{{ formData.planFinishNumber }}</span>
              </div>
              <div class="line"></div>
              <div class="tips">
                计划保养单:<span>{{ formData.planNumber }}</span>
              </div>
            </div>
          </div>
          <div class="info_box">
            <img class="icon" src="@/assets/other/i1.png" alt="" />
            <div class="info_desc">
              <div class="label">超期未保养</div>
              <div class="num">{{ formData.overdueUpkeepNo }}</div>
            </div>
            <img class="line" src="@/assets/other/by_line.png" alt="" />
            <img class="icon" src="@/assets/other/i1.png" alt="" />
            <div class="info_desc">
              <div class="label">合同数</div>
              <div class="num">{{ formData.signatureNo }}</div>
            </div>
          </div>
        </div>
        <div class="map_box">
          <div class="map_breadcrumb" aria-label="当前位置">
            <span
              v-for="(item, index) in mapBreadcrumb"
              :key="item"
              class="map_breadcrumb_part"
            >
              <span v-if="index > 0" class="map_breadcrumb_separator">&gt;</span>
              <button
                v-if="index > 0 && index < mapBreadcrumb.length - 1"
                type="button"
                class="map_breadcrumb_link"
                @click="handleBreadcrumbClick(index)"
              >{{ item }}</button>
              <span v-else :class="{ map_breadcrumb_active: index === mapBreadcrumb.length - 1 }">
                {{ item }}
              </span>
            </span>
          </div>
          <div class="map_content" id="map" :aria-busy="mapLoading"></div>
          <div class="map_status" v-if="mapLoading || mapError" role="status">
            {{ mapLoading ? "地图加载中…" : mapError }}
          </div>
          <ul v-if="mapLegend.length" class="map_legend tech-panel" aria-label="电梯数量区间图例">
            <li v-for="item in mapLegend" :key="item.label" class="map_legend_item">
              <span
                class="map_legend_swatch"
                :style="{ backgroundColor: item.color }"
                aria-hidden="true"
              ></span>
              <span>{{ item.label }}</span>
            </li>
          </ul>
          <div class="center_bottom">
            <div class="anay_box">
              <div class="anay_list">
                <img class="icon" src="@/assets/other/n1.png" alt="" />
                <div class="desc_box">
                  <div class="label">维保工总数</div>
                  <div class="num">{{ formData.upkeepUserNo }}</div>
                </div>
              </div>
              <div class="anay_list">
                <img class="icon" src="@/assets/other/n2.png" alt="" />
                <div class="desc_box">
                  <div class="label">2天未上线</div>
                  <div class="num">{{ formData.upTimeNo }}</div>
                </div>
              </div>
            </div>
            <div class="unline_title">
              <img class="icon" src="@/assets/other/unline_icon.png" alt="" />
              <div class="text">维保工超过2天未上线名单</div>
              <img class="icon2" src="@/assets/other/unline_icon2.png" alt="" />
            </div>
            <div class="table_box">
              <el-table
                :data="upkeepUserListVos"
                class="tableSpec"
                style="height: 100%"
                max-height="254"
              >
                <el-table-column align="center" label="姓名" prop="nickName" />
                <el-table-column align="center" label="所属班组" prop="unitName" />
                <el-table-column align="center" label="联系方式" prop="phonenumber" />
                <el-table-column align="center" label="未上线天数" prop="upDayNo" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="hetong_box item_box">
          <div class="item_title_box">维保合同</div>
          <div class="hetong_content tech-panel">
            <img class="heng_line center_line" src="@/assets/other/h-heng.png" />
            <img class="shu_line center_line" src="@/assets/other/h-shu.png" />

            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h1.png" alt="" />
              <div class="hetong_info">
                <div class="label">已过期</div>
                <div class="num">{{ formData.expiredContractNo }}</div>
              </div>
            </div>
            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h2.png" alt="" />
              <div class="hetong_info">
                <div class="label">进行中</div>
                <div class="num">{{ formData.contractNo }}</div>
              </div>
            </div>
            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h3.png" alt="" />
              <div class="hetong_info">
                <div class="label">即将到期</div>
                <div class="num">{{ formData.expireContractNo }}</div>
              </div>
            </div>
            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h4.png" alt="" />
              <div class="hetong_info">
                <div class="label">未开始</div>
                <div class="num">{{ formData.notStartedContractNo }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="baoxian_box item_box">
          <div class="item_title_box">电梯年检&保险</div>
          <div class="baoxian_content tech-panel">
            <div class="baoxian_top">
              <div class="zongshu">
                <div class="num">{{ formData.yearElevatorNo }}</div>
                <div class="label">在保电梯总数</div>
              </div>
            </div>
            <div class="baoxian_bottom">
              <div class="bao_list">
                <img class="icon" src="@/assets/other/tag.png" />
                <div class="label">年检</div>
                <img class="picture" src="@/assets/other/b1.png" />
                <div class="show_value">
                  <div class="show_list one">
                    年检临期 <span>{{ formData.yearWbNo }}</span>
                  </div>
                  <div class="show_list two">
                    超期未检 <span>{{ formData.overdueNo }}</span>
                  </div>
                  <!-- <div class="show_list three">需复检 <span>50</span></div> -->
                </div>
              </div>
              <div class="bao_list">
                <img class="icon" src="@/assets/other/tag.png" />
                <div class="label">保险</div>
                <img class="picture" src="@/assets/other/b2.png" />
                <div class="show_value">
                  <div class="show_list one">
                    年检临期 <span>{{ formData.insureYearNo }}</span>
                  </div>
                  <div class="show_list two">
                    超期未检 <span>{{ formData.insureOverdueNo }}</span>
                  </div>
                  <!-- <div class="show_list three">需复检 <span>50</span></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="large_bottom"></div>
  </div>
</template>

<script>
import { getSmartYun } from "@/api/user";
import { getMapData } from "@/api/user";
import { areaIdMap, areaNameMap, mapDataToEcharts, mapDataToPoints } from "@/utils";
import { CHART, mapPointSize } from "@/utils/theme";
import { createMapColorScale, getMapFitGeometry, getMap2DLayout, getMapFitView } from "@/utils/mapView";

import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
import "echarts-gl";

import hubeiGeoJson from "@/utils/map.json"; // 湖北省geojson
// 市区geojson示例引入写法（实际建议动态import或按需加载）
import shiyan from "@/utils/cities/shiyan.json";
import shennongjia from "@/utils/cities/shennongjia.json";
import enshi from "@/utils/cities/enshi.json";
import xiangyang from "@/utils/cities/xiangyang.json";
import yichang from "@/utils/cities/yichang.json";
import suizhou from "@/utils/cities/suizhou.json";
import jingmen from "@/utils/cities/jingmen.json";
import jingzhou from "@/utils/cities/jingzhou.json";
import xiaogan from "@/utils/cities/xiaogan.json";
import tianmen from "@/utils/cities/tianmen.json";
import qianjiang from "@/utils/cities/qianjiang.json";
import xiantao from "@/utils/cities/xiantao.json";
import wuhan from "@/utils/cities/wuhan.json";
import huanggang from "@/utils/cities/huanggang.json";
import ezhou from "@/utils/cities/ezhou.json";
import huangshi from "@/utils/cities/huangshi.json";
import xianning from "@/utils/cities/xianning.json";
export default {
  name: "ElevatorLargeIndex",
  components: {},
  data() {
    return {
      maintenanceUserList: [],
      formData: {},
      upKeepDayDetailVo: [],

      url:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage109.360doc.com%2FDownloadImg%2F2025%2F04%2F0321%2F296122601_4_20250403090445718&refer=http%3A%2F%2Fimage109.360doc.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1754030365&t=23cde2530243c9a9130347d2132acb9c",
      time: "",
      upkeepUserListVos: [],

      currentLevel: "province", // 省级或市级
      currentMapName: "hubei", // 当前注册的地图名称
      currentMapTitle: "湖北省",
      // url: "wss://lift.yqdiot.cn/websocket/eventMessage",
      // url: "ws://192.168.0.103:8380/websocket/eventMessage",
      // webSocket: null,
      first: true,
      realWarnList: [],
      code: "",
      parentCode: "",
      codeText: "",
      resizeHandler: null,
      mapResizeTimer: null,
      mapResizeObserver: null,
      mapRotateTimer: null,
      mapRequestId: 0,
      mapFitGeometry: null,
      mapFitDistance: null,
      mapFitCenter: [0, 0, 0],
      mapLoading: false,
      mapError: "",
      mapLegend: [],
      codeList: [
        "420100",
        "420200",
        "420300",
        "420500",
        "420600",
        "420700",
        "420800",
        "420900",
        "421000",
        "421100",
        "421200",
        "421300",
        "422800",
        "429004",
        "429005",
        "429006",
        "429021",
      ],
    };
  },
  computed: {
    mapBreadcrumb() {
      const breadcrumb = ["中国", "湖北"];
      if (this.currentMapTitle && this.currentMapTitle !== "湖北省") {
        breadcrumb.push(this.currentMapTitle);
      }
      return breadcrumb;
    },
  },
  created() {},
  mounted() {
    const query = window.location.hash.split("?")[1];
    // 解析 URL 参数
    const urlParams = new URLSearchParams(query);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      localStorage.setItem("token", token); // 或存到 Vuex
    }

    // 响应式：窗口变化时重绘地图
    this.resizeHandler = () => this.resizeCharts();
    window.addEventListener("resize", this.resizeHandler);
    // 响应式布局下 echarts init 时容器可能尚未 layout 完毕，
    // 延迟 300ms 强制首次 resize，防地图渲染成 0×0
    this.mapResizeTimer = setTimeout(() => {
      this.mapResizeTimer = null;
      this.resizeCharts();
    }, 300);

    this.$nextTick(() => {
      const mapElement = document.getElementById("map");
      if (window.ResizeObserver && mapElement) {
        this.mapResizeObserver = new window.ResizeObserver(() => {
          const chart = echarts.getInstanceByDom(mapElement);
          if (chart && !chart.isDisposed()) {
            chart.resize();
            this.updateMapResponsive(chart);
          }
        });
        this.mapResizeObserver.observe(mapElement);
      }
      this.getData();
      this.getTime();
      this.code = localStorage.getItem("code") || "";
      if (
        this.code == "429004" ||
        this.code == "429005" ||
        this.code == "429006" ||
        this.code == "429021"
      ) {
        this.parentCode = this.code;
      } else {
        this.parentCode = this.code.slice(0, 4) + "00";
      }
      this.codeText = areaIdMap[Number(this.parentCode)] || null;
      if (this.codeText) {
        this.currentLevel = "city";
        this.loadCityMap(this.codeText);
      } else {
        this.initMap();
      }
    });
  },
  beforeDestroy() {
    this.mapRequestId += 1;
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
    clearTimeout(this.mapResizeTimer);
    clearTimeout(this.mapRotateTimer);
    if (this.mapResizeObserver) {
      this.mapResizeObserver.disconnect();
      this.mapResizeObserver = null;
    }
    if (this.myChart && !this.myChart.isDisposed()) {
      this.myChart.dispose();
    }
  },

  methods: {
    resizeCharts() {
      const element = document.getElementById("map");
      const chart = element && echarts.getInstanceByDom(element);
      if (chart && !chart.isDisposed()) {
        chart.resize();
        this.updateMapResponsive(chart);
      }
    },
    getMapViewport(chart) {
      const mapElement = chart.getDom();
      const width = Math.max(1, chart.getWidth());
      const height = Math.max(1, chart.getHeight());
      const paddingX = width * 0.01;
      const paddingY = height * 0.01;
      let top = paddingY;
      // 与电梯大屏一致：使用完整容器，仅避开容器内的顶部统计卡片。
      const boardElement = mapElement.parentElement.querySelector(".map_board");
      if (boardElement) {
        top = Math.max(top, boardElement.offsetTop + boardElement.offsetHeight - mapElement.offsetTop + paddingY);
      }
      top = Math.min(top, height - 1);
      return {
        left: paddingX,
        top,
        width: Math.max(1, width - paddingX * 2),
        height: Math.max(1, height - top - paddingY),
      };
    },
    updateMapResponsive(chart) {
      if (chart.getWidth() <= 0 || chart.getHeight() <= 0) return;
      const viewport = this.getMapViewport(chart);
      const model = chart.getModel();
      if (!model) return;
      const geo3DModel = model.getComponent("geo3D", 0);
      if (geo3DModel && geo3DModel.coordinateSystem && this.mapFitGeometry) {
        const coordinateSystem = geo3DModel.coordinateSystem;
        const viewControl = geo3DModel.getModel("viewControl");
        const fitView = getMapFitView(
          coordinateSystem.size,
          viewport,
          viewControl.get("alpha"),
          viewControl.get("beta"),
          coordinateSystem.viewGL.camera.fov,
          this.mapFitGeometry.points,
          this.currentLevel === "city"
        );
        const zoomRatio = this.mapFitDistance
          ? viewControl.get("distance") / this.mapFitDistance
          : 1;
        const currentCenter = viewControl.get("center") || [0, 0, 0];
        const center = fitView.center.map((value, index) => (
          value + currentCenter[index] - this.mapFitCenter[index]
        ));
        this.mapFitDistance = fitView.distance;
        this.mapFitCenter = fitView.center;
        chart.setOption({
          geo3D: {
            ...viewport,
            viewControl: {
              distance: fitView.distance * zoomRatio,
              center,
              maxDistance: Math.max(400, fitView.distance * 3),
            },
          },
        });
        return;
      }
      const geoModel = model.getComponent("geo", 0);
      if (geoModel && geoModel.coordinateSystem) {
        const coordinateSystem = geoModel.coordinateSystem;
        const bounds = coordinateSystem.getBoundingRect();
        const aspect = bounds.width / bounds.height * coordinateSystem.aspectScale;
        if (Number.isFinite(aspect) && aspect > 0) {
          chart.setOption({ geo: getMap2DLayout(viewport, aspect) });
        }
      }
    },
    hasWebGL() {
      try {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (!context) return false;
        const extension = context.getExtension("WEBGL_lose_context");
        if (extension) extension.loseContext();
        return true;
      } catch (error) {
        return false;
      }
    },
    createMap3DOption(mapName, geoJson, mapData, pointData, formatMapTooltip) {
      const regionValues = mapData.reduce((values, item) => {
        values[item.name] = Math.max(0, Math.round(Number(item.value) || 0));
        return values;
      }, {});
      const regionNames = [
        ...mapData.map((item) => item.name),
        ...(geoJson.features || []).map((feature) => (feature.properties || {}).name),
      ].filter((name, index, names) => name && names.indexOf(name) === index);
      const featureMap = (geoJson.features || []).reduce((features, feature) => {
        const properties = feature.properties || {};
        features[properties.name] = properties;
        return features;
      }, {});
      const regionMax = Math.max(0, ...Object.values(regionValues));
      const mapColorScale = createMapColorScale(regionMax);
      this.mapLegend = mapColorScale.legend;
      const pointMax = Math.max(0, ...pointData.map((point) => Number(point.value[2]) || 0));
      const point3DData = pointData.filter((point) => Number(point.value[2]) > 0).map((point) => {
        const count = Math.round(Number(point.value[2]) || 0);
        return {
          name: point.name,
          elevatorCount: count,
          value: [point.value[0], point.value[1], 1 + count / pointMax * 2.5, count],
        };
      });
      const bar3DData = point3DData.map((point) => ({
        name: point.name,
        elevatorCount: point.elevatorCount,
        value: point.value.slice(0, 3),
      }));
      // 建立从零开始的高度轴，使光柱和亮点处于地图顶面之上。
      point3DData.push({
        name: "",
        value: [0, 0, 0, 0],
        symbolSize: 0,
        itemStyle: { opacity: 0 },
      });
      const regionClickData = regionNames.reduce((regions, name) => {
        const properties = featureMap[name];
        const coordinates = properties && (properties.center || properties.centroid);
        if (Array.isArray(coordinates) && coordinates.length >= 2) {
          regions.push({
            name,
            elevatorCount: regionValues[name] || 0,
            value: [Number(coordinates[0]), Number(coordinates[1]), 0, regionValues[name] || 0],
          });
        }
        return regions;
      }, []);
      const viewport = this.getMapViewport(this.myChart);
      const fitView = getMapFitView(
        this.mapFitGeometry.size, viewport, 46, 0, 50, this.mapFitGeometry.points,
        this.currentLevel === "city"
      );
      this.mapFitDistance = fitView.distance;
      this.mapFitCenter = fitView.center;
      const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const formatRegionLabel = (params) => {
        const name = params.name || "";
        const count = regionValues[name] || 0;
        return count > 0 ? `{name|${name}}{count| ${count}}` : `{name|${name || " "}}`;
      };
      const labelRich = {
        name: {
          color: "#ECF8FF", fontSize: 13, lineHeight: 18,
          textBorderColor: "#031621", textBorderWidth: 2,
        },
        count: {
          color: "#7FF3FF", fontSize: 12, fontWeight: "bold", padding: [0, 0, 0, 4],
          textBorderColor: "#031621", textBorderWidth: 2,
        },
      };
      return {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item", formatter: formatMapTooltip,
          backgroundColor: "rgba(4, 24, 40, 0.94)", borderColor: "#2B8499",
          textStyle: { color: "#D9F0F1", fontSize: 14 },
        },
        geo3D: {
          show: true, map: mapName, ...viewport,
          regions: regionNames.map((name) => ({
            name, itemStyle: { color: mapColorScale.getColor(regionValues[name]) },
          })),
          regionHeight: 4.5, boxWidth: 110, boxDepth: "auto", boxHeight: 11,
          shading: "color", environment: "none",
          light: {
            main: { intensity: 1.7, alpha: 38, beta: -25, shadow: false },
            ambient: { intensity: 0.48 },
          },
          postEffect: { enable: false },
          viewControl: {
            projection: "perspective", alpha: 46, beta: 0,
            distance: fitView.distance, center: fitView.center,
            maxDistance: Math.max(400, fitView.distance * 3),
            minAlpha: 40, maxAlpha: 65, minBeta: -12, maxBeta: 12,
            autoRotate: !reduceMotion && !document.hidden, autoRotateSpeed: 1.2,
            rotateSensitivity: 0, zoomSensitivity: 1, panSensitivity: 1,
          },
          label: {
            show: true, formatter: formatRegionLabel, distance: 0, opacity: 1,
            fontFamily: "Microsoft YaHei, Arial, sans-serif", rich: labelRich,
          },
          itemStyle: { color: "#123A52", borderColor: "#2A86A6", borderWidth: 0.8, opacity: 1 },
          emphasis: {
            label: {
              show: true, formatter: formatRegionLabel,
              rich: {
                name: { ...labelRich.name, color: "#FFFFFF", fontSize: 14, fontWeight: "bold" },
                count: { ...labelRich.count, color: "#FFF176", fontSize: 13 },
              },
            },
            itemStyle: { color: "#1E5572", borderColor: "#9AC4C8" },
          },
        },
        series: [
          {
            name: "区域下钻", type: "scatter3D", coordinateSystem: "geo3D", geo3DIndex: 0,
            data: regionClickData, symbolSize: 32, itemStyle: { opacity: 0 }, label: { show: false },
          },
          {
            name: "电梯光柱", type: "bar3D", coordinateSystem: "geo3D", geo3DIndex: 0,
            data: bar3DData, barSize: 2.8, shading: "lambert",
            itemStyle: { color: "#00D4FF", opacity: 0.55 },
            emphasis: { itemStyle: { color: "#7FF3FF", opacity: 0.9 } },
          },
          {
            name: "电梯数量", type: "scatter3D", coordinateSystem: "geo3D", geo3DIndex: 0,
            data: point3DData, symbolSize: (value) => mapPointSize(value, 3, pointMax, 8, 16),
            blendMode: "lighter",
            itemStyle: { color: CHART.mapPoint, opacity: 1, borderColor: CHART.mapPointBorder, borderWidth: 2 },
            label: { show: false },
            emphasis: { itemStyle: { color: "#FFF176", opacity: 1 }, label: { show: false } },
          },
        ],
      };
    },
    handleBreadcrumbClick(index) {
      if (this.currentLevel === "city" && index === 1) {
        this.backToProvince();
      }
    },
    initMap(mapName = "hubei", geoJson = hubeiGeoJson, mapTitle = "湖北省") {
      this.currentMapTitle = mapTitle;
      const requestId = ++this.mapRequestId;
      clearTimeout(this.mapRotateTimer);
      this.mapRotateTimer = null;
      this.mapFitGeometry = null;
      this.mapFitDistance = null;
      this.mapFitCenter = [0, 0, 0];
      this.mapLegend = [];
      this.mapLoading = true;
      this.mapError = "";
      const mapElement = document.getElementById("map");
      const myChart = echarts.getInstanceByDom(mapElement) || echarts.init(mapElement, null, {
        devicePixelRatio: Math.min(window.devicePixelRatio || 1, 2),
      });
      this.myChart = myChart;
      myChart.off("click");
      echarts.registerMap(mapName, geoJson);
      let useMap3D = this.hasWebGL();
      const areaId = this.currentLevel === "province" ? "42" : areaNameMap[mapTitle] || mapTitle;
      const renderMap = (mapList) => {
        if (requestId !== this.mapRequestId || myChart.isDisposed() || this.myChart !== myChart) return;
        const mapData = mapDataToEcharts(mapList, geoJson);
        const pointData = mapDataToPoints(mapList, geoJson);
        this.mapFitGeometry = Object.freeze(getMapFitGeometry(geoJson, pointData));
        const layout2D = getMap2DLayout(
          this.getMapViewport(myChart), this.mapFitGeometry.size[0] / this.mapFitGeometry.size[2]
        );
        const pointMax = Math.max(...pointData.map((p) => Number(p.value[2]) || 0), 0);
        const normalizeMapValue = (rawValue) => {
          const value = Array.isArray(rawValue)
            ? (rawValue[3] !== undefined ? rawValue[3] : rawValue[2])
            : rawValue;
          const numericValue = Number(value);
          return Number.isFinite(numericValue) ? numericValue : 0;
        };
        const formatMapTooltip = (params) => {
          const data = params.data;
          const value = data && data.elevatorCount !== undefined
            ? normalizeMapValue(data.elevatorCount)
            : normalizeMapValue(params.value);
          const name = params.name || (data && data.name) || "";
          return value > 0 ? `${name}<br/>电梯数量：${value} 台` : name;
        };
        const option2D = {
          title: {
            show: false,
            text: mapTitle,
            left: "center",
            textStyle: {
              color: "#fff",
              fontSize: 18,
              fontWeight: "bold",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: formatMapTooltip,
          },
          geo: {
            map: mapName,
            roam: true,
            scaleLimit: { min: 0.85, max: 1.8 },
            ...layout2D,
            zoom: 1,
            label: {
              show: true,
              color: "#C9E6F0",
              fontSize: 12,
              textBorderColor: "#07222F",
              textBorderWidth: 1,
            },
            itemStyle: {
              areaColor: "#0B2E46",
              borderColor: "#2B84A6",
            },
            emphasis: {
              itemStyle: { areaColor: "#f0a31a" },
            },
          },
          series: [
            {
              name: mapTitle,
              type: "map",
              map: mapName,
              geoIndex: 0,
              roam: false,
              label: {
                show: true,
                color: "#C9E6F0",
                fontSize: 12,
                textBorderColor: "#07222F",
                textBorderWidth: 1,
              },
              itemStyle: {
                areaColor: "#0B2E46",
                borderColor: "#2B84A6",
              },
              emphasis: {
                label: { show: true, color: "#fff", fontWeight: "bold" },
                itemStyle: { areaColor: "#f0a31a" },
              },
              data: mapData,
            },
            {
              name: "电梯数量",
              type: "effectScatter",
              coordinateSystem: "geo",
              geoIndex: 0,
              z: 3,
              data: pointData,
              symbolSize: (value) => mapPointSize(value, 2, pointMax, 11, 26),
              showEffectOn: "render",
              rippleEffect: {
                brushType: "stroke",
                scale: 3,
                period: 3,
              },
              itemStyle: {
                color: CHART.mapPoint,
                shadowBlur: 12,
                shadowColor: "rgba(255, 176, 0, 0.9)",
                borderColor: CHART.mapPointBorder,
                borderWidth: 1,
              },
              label: {
                show: false,
              },
              emphasis: {
                scale: 1.2,
                label: { show: false },
              },
              tooltip: {
                formatter: formatMapTooltip,
              },
            },
          ],
        };

        try {
          const option = useMap3D
            ? this.createMap3DOption(mapName, geoJson, mapData, pointData, formatMapTooltip)
            : option2D;
          myChart.setOption(option, true);
        } catch (error) {
          useMap3D = false;
          this.mapFitGeometry = null;
          this.mapFitDistance = null;
          this.mapLegend = [];
          myChart.setOption(option2D, true);
        }
        this.updateMapResponsive(myChart);
        if (useMap3D) {
          // 与电梯大屏一样，将地图面事件绑定到透明区域系列以支持任意区域下钻。
          const geo3DModel = myChart.getModel().getComponent("geo3D", 0);
          if (geo3DModel) {
            geo3DModel.seriesIndex = 0;
            const geo3DView = myChart.getViewOfComponentModel(geo3DModel);
            const polygonMesh = geo3DView && geo3DView._geo3DBuilder && geo3DView._geo3DBuilder._polygonMesh;
            if (polygonMesh) polygonMesh.seriesIndex = 0;
            if (geo3DModel.getModel("viewControl").get("autoRotate")) {
              this.mapRotateTimer = setTimeout(() => {
                this.mapRotateTimer = null;
                if (!myChart.isDisposed() && this.myChart === myChart) {
                  myChart.setOption({ geo3D: { viewControl: { autoRotate: false } } });
                }
              }, 6000);
            }
          }
        }
        myChart.off("click");
        myChart.on("click", (params) => {
          if (this.mapLoading || requestId !== this.mapRequestId) return;
          const isMapRegion = ["map", "scatter3D", "bar3D"].includes(params.seriesType)
            || params.componentType === "geo3D";
          if (this.currentLevel !== "province" || !isMapRegion) return;
          let regionName = params.name || (params.data && params.data.name);
          if (!regionName && Number.isInteger(params.dataIndex)) {
            const seriesModel = myChart.getModel().getSeriesByIndex(params.seriesIndex);
            const seriesData = seriesModel && seriesModel.getData();
            regionName = seriesData && seriesData.getName(params.dataIndex);
          }
          if (regionName) this.loadCityMap(regionName);
        });
      };
      getMapData({ areaId }).then((res) => {
        renderMap(res && Array.isArray(res.data) ? res.data : []);
      }).catch(() => {
        if (requestId !== this.mapRequestId || myChart.isDisposed() || this.myChart !== myChart) return;
        this.mapError = "电梯数量数据获取失败";
        renderMap([]);
      }).finally(() => {
        if (requestId === this.mapRequestId && !myChart.isDisposed() && this.myChart === myChart) {
          this.mapLoading = false;
        }
      });
    },
    loadCityMap(cityName) {
      // 市名转拼音映射（示例，建议完善）
      const cityMap = {
        十堰市: { mapName: "shiyan", geoJson: shiyan },
        神农架林区: { mapName: "shennongjia", geoJson: shennongjia },
        恩施土家族苗族自治州: { mapName: "enshi", geoJson: enshi },
        襄阳市: { mapName: "xiangyang", geoJson: xiangyang },
        宜昌市: { mapName: "yichang", geoJson: yichang },
        随州市: { mapName: "suizhou", geoJson: suizhou },
        荆门市: { mapName: "jingmen", geoJson: jingmen },
        荆州市: { mapName: "jingzhou", geoJson: jingzhou },
        孝感市: { mapName: "xiaogan", geoJson: xiaogan },
        天门市: { mapName: "tianmen", geoJson: tianmen },
        潜江市: { mapName: "qianjiang", geoJson: qianjiang },
        仙桃市: { mapName: "xiantao", geoJson: xiantao },
        武汉市: { mapName: "wuhan", geoJson: wuhan },
        黄冈市: { mapName: "huanggang", geoJson: huanggang },
        鄂州市: { mapName: "ezhou", geoJson: ezhou },
        黄石市: { mapName: "huangshi", geoJson: huangshi },
        咸宁市: { mapName: "xianning", geoJson: xianning },
        // 其他市对应json要补充
      };
      const city = cityMap[cityName];
      if (!city) {
        alert("未找到该市的地图数据！");
        return;
      }
      this.currentLevel = "city";
      this.currentMapName = city.mapName;
      this.initMap(city.mapName, city.geoJson, cityName); // 传入市区地图参数
    },
    backToProvince() {
      if (this.currentLevel === "city") {
        this.currentLevel = "province";
        this.currentMapName = "hubei";
        this.initMap("hubei", hubeiGeoJson, "湖北省");
      }
    },
    getData() {
      getSmartYun().then((res) => {
        const data =
          res && res.data && typeof res.data === "object" && !Array.isArray(res.data)
            ? res.data
            : {};
        // 接口无数据时保持对象结构，避免模板读取 formData.planNumber 报错。
        this.formData = { ...this.formData, ...data };
        this.maintenanceUserList = Array.isArray(data.maintenanceUserList)
          ? data.maintenanceUserList.filter((item) => item && typeof item === "object")
          : [];
        this.upkeepUserListVos = Array.isArray(data.upkeepUserListVos)
          ? data.upkeepUserListVos.filter((item) => item && typeof item === "object")
          : [];
        this.upKeepDayDetailVo = Array.isArray(data.upKeepDayDetailVo)
          ? data.upKeepDayDetailVo.filter((item) => item && typeof item === "object")
          : [];

        this.$nextTick(() => {
          this.swiperInitBaoyang();
          this.swiperInitStep();
        });
      }).catch(() => {});
    },
    swiperInitStep() {
      new Swiper(".baoyang_step_box", {
        slidesPerView: "1",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    swiperInitBaoyang() {
      new Swiper(".baoyang_box", {
        slidesPerView: "2",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    getStatus(type) {
      if (type == 1) {
        return "待领取";
      } else if (type == 2) {
        return "进行中";
      } else if (type == 3) {
        return "已完成";
      } else {
        return "-";
      }
    },
    getTime() {
      this.getCurrentDateTime();
      setInterval(() => {
        this.getCurrentDateTime();
      }, 1000);
    },

    getCurrentDateTime() {
      let now = new Date();
      // 获取日期部分
      let year = now.getFullYear();
      let month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，所以要+1
      let day = now.getDate().toString().padStart(2, "0");
      // 获取时间部分
      let hours = now.getHours().toString().padStart(2, "0");
      let minutes = now.getMinutes().toString().padStart(2, "0");
      let seconds = now.getSeconds().toString().padStart(2, "0");
      // 获取星期部分
      let weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let weekDay = weekDays[now.getDay()];
      // 组合成目标格式
      this.time = `${year}.${month}.${day} ${hours}:${minutes}:${seconds} ${weekDay}`;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/viewport.scss";

.large_main {
  position: relative;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background: #031321 url("@/assets/image/big_bg.png") center / cover no-repeat;
  padding: 0 vw(20);
  .top_title {
    background: url("@/assets/image/large_top_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: vh(90);
    position: relative;
    .title_text {
      width: 100%;
      text-align: center;
      padding-top: vh(6);
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: vw(40);
      color: #fff;
      letter-spacing: vw(4);
    }
    .time {
      position: absolute;
      margin: auto;
      right: vw(60);
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 700;
      font-size: vw(18);
      color: #fff;
      bottom: vh(16);
    }
  }

  .large_content {
    height: calc(100% - vh(154));
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left {
      width: vw(400);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .baoyang_success {
        width: 100%;

        .baoyang_content {
          height: vh(260);
          width: calc(100% - vw(40));
          padding: vh(10) vw(20);
          .baoyang_box {
            position: relative;
            height: 100%;
            width: 100%;
            overflow: hidden;

            .baoyang_list {
              padding: 5px auto;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              .list_item {
                width: 100%;
                background: rgba(8, 85, 150, 0.29);
                height: vh(120);
                padding: 0 vw(10);
                .baoyang_title {
                  height: vh(38);
                  width: 100%;
                  border-bottom: 1px dashed #1e4f7b;
                  font-weight: 700;
                  font-size: vw(14);
                  color: #fff;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;

                  .baoyang_tag {
                    padding: 0 vw(10);
                    height: vh(24);
                    line-height: vh(24);
                    background: rgba(79, 158, 232, 0.1);
                    box-shadow: inset 0px 0px 20px 0px rgba(0, 149, 250, 0.5);
                    border-radius: 2px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        135deg,
                        rgba(0, 255, 255, 1),
                        rgba(0, 149.00000631809235, 250.00000029802322, 1),
                        rgba(0, 149.00000631809235, 250.00000029802322, 1)
                      )
                      1 1;
                  }
                }
                .baoyang_list_main {
                  height: vh(82);
                  width: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: space-evenly;
                  .icon {
                    width: vw(20);
                    height: vh(10);
                  }
                  .tips_box {
                    width: vw(140);
                    height: vh(69);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .tips {
                      background: url("@/assets/other/beijing.png") no-repeat center;
                      background-size: 100% 100%;
                      width: 100%;
                      height: vh(24);
                      font-family: Microsoft YaHei, Microsoft YaHei;
                      font-weight: 400;
                      font-size: vw(12);
                      color: #c9eaf7;
                      line-height: vh(24);
                      span {
                        font-weight: 700;
                        font-size: vw(12);
                        color: #09b5ff;
                        margin-left: vw(5);
                      }
                    }
                    .line {
                      width: vw(140);
                      height: 0px;
                      border-bottom: 1px dashed #6e9cc5;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .today_bao {
        height: calc(100% - vh(290));
        margin-top: vh(10);
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
          .baoyang_step_box {
            position: relative;
            height: 100%;
            width: 100%;
            overflow: hidden;
          }
        .today_content {
          width: calc(100% - vw(40));
          padding: vh(10) vw(20);
          flex: 1;

          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .step_box {
          width: 100%;

          .step_heng {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            .step_img_box {
              width: vw(52);
            }
            .step_desc {
              width: vw(60);
              height: vh(48);
              margin-left: vw(17);
            }
            .line_box {
              height: vh(52);
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              .line {
                height: 0;
                width: 100%;
                border-bottom: 1px dashed #6e9cc5;
              }
            }
          }

          .step_list {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            &.one {
              height: vh(88);
              .step_desc {
                height: vh(48);
                width: vw(328);
                text-align: left;
                font-weight: 400;
                font-size: vw(14);
                color: #fff;
              }
            }
            &.two {
              height: vh(100);
              .step_desc {
                width: vw(328);
                height: vh(60);
                display: flex;
                align-items: center;
              }
            }
            .step_img_box {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              .line {
                flex: 1;
                width: 0px;
                border-left: 1px dashed #6e9cc5;
              }
            }
          }
          .step_desc {
            background: rgba(0, 30, 58, 0.72);
            box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
            border-radius: 0px 0px 0px 0px;
            border: 1px solid rgba(103, 192, 255, 0.46);
            padding: vh(10) vw(20);
          }
          .step_icon {
            width: vw(52);
            height: vw(52);
          }
          .step_title {
            font-weight: 700;
            font-size: vw(12);
            line-height: vh(16);
            background: linear-gradient(90deg, #ffffff 45%, #8ed8ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .location {
          width: 100%;
          height: vh(30);
          background: rgba(79, 158, 232, 0.1);
          box-shadow: inset 0px 0px 20px 0px rgba(0, 149, 250, 0.5);
          border-radius: 2px;
          border: 1px solid;
          border-image: linear-gradient(
              135deg,
              rgba(0, 255, 255, 1),
              rgba(0, 149.00000631809235, 250.00000029802322, 1),
              rgba(0, 149.00000631809235, 250.00000029802322, 1)
            )
            1 1;
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: vw(14);
          color: #fff;
          .address_icon {
            width: vw(16);
            height: vw(16);
            margin: 0 vw(10);
          }
        }
      }
    }

    .center {
      width: calc(100% - vw(820));
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-start;
      position: relative;
      .center_top {
        width: 100%;
        height: vh(134);
        flex: 0 0 vh(134);
        order: 1;
        display: flex;
        justify-content: space-between;
        .all_baoyang {
          height: 100%;
          width: 45%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          background: url("@/assets/other/by_bg.png") no-repeat center;
          background-size: 100% 100%;
          .icon {
            width: 1px;
            height: vh(50);
          }
          .tips_box {
            width: vw(140);
            height: vh(69);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .tips {
              background: url("@/assets/other/beijing.png") no-repeat center;
              background-size: 100% 100%;
              width: 100%;
              height: vh(24);
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: vw(12);
              color: #c9eaf7;
              line-height: vh(24);
              span {
                font-weight: 700;
                font-size: vw(12);
                color: #09b5ff;
                margin-left: vw(5);
              }
            }
            .line {
              width: vw(140);
              height: 0px;
              border-bottom: 1px dashed #6e9cc5;
            }
          }
        }
        .info_box {
          flex: 1;
          margin-left: vw(10);
          background: url("@/assets/other/by_bg.png") no-repeat center;
          background-size: 100% 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          .icon {
            width: vw(76);
            height: vh(56);
          }
          .line {
            width: 1px;
            height: vh(50);
          }
          .info_desc {
            height: vh(56);
            .label {
              font-weight: 700;
              font-size: vw(14);
              color: #fff;
            }
            .num {
              font-family: $font-number;
              font-weight: 700;
              font-size: vw(28);
              background: linear-gradient(90deg, #00fffd 0%, #0095fa 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
        }
      }

      .center_bottom {
        width: vw(500);
        max-width: calc(100% - vw(20));
        height: vh(350);
        box-sizing: border-box;
        position: absolute;
        right: vw(10);
        bottom: vh(10);
        z-index: 99;
        padding: vh(14);
        background: rgba(0, 30, 58, 0.42);
        box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
        border-radius: 0px;
        border: 2px solid rgba(103, 192, 255, 0.46);
        // 信息面板只作为地图上的视觉层，不拦截地图拖动事件
        pointer-events: none;
        .anay_box {
          width: 100%;
          height: vh(60);
          display: flex;
          .anay_list {
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            .icon {
              width: vw(82);
              height: vh(61);
            }
            .desc_box {
              height: 100%;
              flex: 1;
              margin-left: vw(12);
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;
              .label {
                font-weight: 700;
                font-size: vw(16);
                color: #fff;
              }
              .num {
                font-weight: 700;
                font-size: vw(22);
                color: #4aedff;
                line-height: vh(32);
                text-shadow: 0px 4px 10px #00bfff;
              }
            }
          }
        }
        .unline_title {
          width: 100%;
          display: flex;
          align-items: center;
          height: vh(20);
          margin: vh(10) auto vh(6);
          .icon {
            width: vw(12);
            height: vw(12);
          }
          .text {
            flex: 1;
            text-align: left;
            font-weight: 700;
            margin-left: vw(6);
            font-size: vw(16);
            color: #58baff;
          }
          .icon2 {
            width: vw(24);
            height: vh(10);
          }
        }
        .table_box {
          height: vh(210);
          width: 100%;
        }
      }

      .map_box {
        position: relative;
        order: 2;
        flex: 1 1 auto;
        min-height: 0;
        width: 100%;
        margin: vh(10) 0;
        display: flex;
        flex-direction: column;
        .map_breadcrumb {
          position: absolute;
          top: vh(12);
          left: vw(20);
          z-index: 6;
          display: flex;
          align-items: center;
          height: vh(28);
          line-height: 1;
          color: #eefaff;
          font-size: vw(14);
          letter-spacing: vw(0.5);
          text-shadow: 0 0 8px rgba(0, 212, 255, 0.45);
          white-space: nowrap;
          .map_breadcrumb_part {
            display: inline-flex;
            align-items: center;
            height: 100%;
          }
          .map_breadcrumb_separator {
            margin: 0 vw(8);
            color: #5ab8d3;
          }
          .map_breadcrumb_link,
          .map_breadcrumb_active {
            display: inline-flex;
            align-items: center;
            height: 100%;
            font: inherit;
            line-height: 1;
          }
          .map_breadcrumb_link {
            padding: 0;
            border: 0;
            color: #8bcfe2;
            background: transparent;
            cursor: pointer;
            pointer-events: auto;
            text-shadow: inherit;
            &:hover,
            &:focus-visible {
              color: #00eeff;
              outline: none;
              text-shadow: 0 0 10px rgba(0, 238, 255, 0.8);
            }
          }
          .map_breadcrumb_active {
            color: #00eeff;
            text-shadow: 0 0 10px rgba(0, 238, 255, 0.75);
          }
        }
        .map_status {
          position: absolute;
          top: vh(12);
          right: vw(16);
          z-index: 100;
          padding: vh(6) vw(10);
          color: #c9e6f0;
          font-size: vw(14);
          background: rgba(4, 24, 40, 0.9);
          pointer-events: none;
        }
        .map_legend {
          position: absolute;
          z-index: 8;
          left: vw(12);
          right: calc(vw(500) + vw(20));
          bottom: vh(16);
          min-height: vh(38);
          box-sizing: border-box;
          margin: 0;
          padding: vh(8) vw(12);
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-start;
          gap: vh(8) vw(14);
          list-style: none;
          color: #d9f0f1;
          font-size: vw(12);
          background: rgba(3, 25, 43, 0.86);
          border: 1px solid rgba(0, 212, 255, 0.28);
          pointer-events: none;
          .map_legend_item {
            display: inline-flex;
            align-items: center;
            white-space: nowrap;
          }
          .map_legend_swatch {
            width: vw(20);
            height: vh(10);
            margin-right: vw(6);
            border: 1px solid rgba(154, 196, 200, 0.45);
            border-radius: 2px;
            box-shadow: 0 0 8px rgba(0, 212, 255, 0.18);
          }
        }
        .map_content {
          width: 100%;
          flex: 1 1 auto;
          min-height: 0;
          background: transparent;
          cursor: grab;
          &:active {
            cursor: grabbing;
          }
        }
      }
    }

    .right {
      width: vw(400);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .hetong_box {
        width: 100%;

        .hetong_content {
          width: calc(100% - vw(20));
          height: vh(218);
          padding: vh(20) vw(10);
          display: flex;
          flex-wrap: wrap;
          position: relative;
          .heng_line {
            width: vw(320);
            height: vh(2);
          }
          .shu_line {
            width: vw(2);
            height: vh(130);
          }
          .center_line {
            position: absolute;
            margin: auto;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
          }
          .hetong_list:nth-of-type(1) .hetong_info .num {
            color: $color-danger;
          }
          .hetong_list:nth-of-type(2) .hetong_info .num {
            color: $color-success;
          }
          .hetong_list:nth-of-type(3) .hetong_info .num {
            color: $color-warning;
          }
          .hetong_list:nth-of-type(4) .hetong_info .num {
            color: #b0b0b0;
          }
          .hetong_list {
            width: 50%;
            height: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon {
              width: vw(92);
              height: vh(68);
              margin-right: vw(10);
            }

            .hetong_info {
              height: vh(68);
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .label {
                font-weight: 700;
                font-size: vw(16);
                color: #fff;
              }
              .num {
                font-family: $font-number;
                font-weight: 700;
                font-size: vw(32);
                line-height: vh(35);
              }
            }
          }
        }
      }

      .baoxian_box {
        height: calc(100% - vh(320));
        width: 100%;
        .baoxian_content {
          height: calc(100% - vh(82));
          padding: vh(20);
          width: calc(100% - vw(40));
          display: flex;
          flex-direction: column;
          .baoxian_top {
            width: 100%;
            box-sizing: border-box;
            height: vh(176);
            background: rgba(0, 30, 58, 0.72);
            box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
            border-radius: 0px;
            border: 1px solid rgba(103, 192, 255, 0.46);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            .zongshu {
              background: url("@/assets/other/zongshu.png") no-repeat center;
              background-size: 100% 100%;
              width: vw(296);
              height: vh(120);
              display: flex;
              margin-bottom: vh(10);
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              .num {
                font-family: YouSheBiaoTiHei;
                font-weight: 400;
                font-size: vw(36);
                color: #09b5ff;
              }
              .label {
                font-family: YouSheBiaoTiHei;
                font-weight: 400;
                font-size: vw(22);
                color: #fff;
                margin-top: vh(10);
              }
            }
          }

          .baoxian_bottom {
            flex: 1;
            width: 100%;
            margin-top: vh(20);
            display: flex;
            justify-content: space-between;
            .bao_list {
              width: calc(50% - vw(10));
              box-sizing: border-box;
              background: url("@/assets/other/bao_bg.png") no-repeat center;
              background-size: 100% 100%;
              display: flex;
              flex-direction: column;
              padding: vh(10);
              .icon {
                width: vw(32);
                height: vh(6);
              }
              .label {
                font-family: YouSheBiaoTiHei;
                font-weight: 400;
                font-size: vw(18);
                color: #fff;
                width: 100%;
                text-align: left;
              }
              .picture {
                width: vw(70);
                height: vw(70);
                margin: 0 auto 0;
              }
              .show_value {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                .show_list {
                  width: calc(100% - vw(10));
                  height: vh(24);
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  font-weight: 400;
                  font-size: vw(12);
                  padding-left: vw(10);
                  color: #fff;
                  position: relative;
                  span {
                    position: absolute;
                    margin: auto;
                    line-height: vh(24);
                    left: 0;
                    right: 0;
                  }
                  &.one {
                    span {
                      font-weight: 700;
                      font-size: vw(12);
                      color: #f88d3f;
                    }
                    background: linear-gradient(
                      270deg,
                      rgba(245, 140, 64, 0.2) 0%,
                      rgba(245, 140, 64, 0) 100%
                    );
                    border-radius: 0px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        270deg,
                        rgba(245.00000059604645, 140.00000685453415, 64.00000378489494, 0.05000000074505806),
                        rgba(245.00000059604645, 140.00000685453415, 64.00000378489494, 0.47999998927116394),
                        rgba(245.00000059604645, 140.00000685453415, 64.00000378489494, 0)
                      )
                      1 1;
                  }
                  &.two {
                    span {
                      font-weight: 700;
                      font-size: vw(12);
                      color: #ff403f;
                    }
                    background: linear-gradient(
                      270deg,
                      rgba(255, 64, 63, 0.26) 0%,
                      rgba(255, 64, 63, 0) 100%
                    );
                    border-radius: 0px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        270deg,
                        rgba(255, 64.00000378489494, 63.000000044703484, 0.14000000059604645),
                        rgba(255, 64.00000378489494, 63.000000044703484, 0.6299999952316284),
                        rgba(255, 64.00000378489494, 63.000000044703484, 0)
                      )
                      1 1;
                  }
                  &.three {
                    span {
                      font-weight: 700;
                      font-size: vw(12);
                      color: #f3e229;
                    }
                    background: linear-gradient(
                      270deg,
                      rgba(243, 226, 41, 0.23) 0%,
                      rgba(243, 226, 41, 0) 100%
                    );
                    border-radius: 0px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        270deg,
                        rgba(243.00000071525574, 226.0000017285347, 41.00000135600567, 0.14000000059604645),
                        rgba(243.00000071525574, 226.0000017285347, 41.00000135600567, 0.6899999976158142),
                        rgba(243.00000071525574, 226.0000017285347, 41.00000135600567, 0)
                      )
                      1 1;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .large_bottom {
    background: url("@/assets/image/large_bottom_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: vh(44);
  }
}

.item_box {
  display: flex;
  flex-direction: column;
  width: 100%;
  .item_title_box {
    width: calc(100% - vw(40));
    height: vh(36);
    background: url("@/assets/image/box_title_bg.png") no-repeat center;
    background-size: 100% 100%;
    margin-bottom: vh(6);
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: vw(24);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: vw(40);
    &.other {
      background: url("@/assets/image/center_title_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
    .tags_box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .tips_view {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: vw(14);
        color: #d6cfcd;
        font-family: Microsoft YaHei;
        .icon {
          width: vw(16);
          height: vw(16);
          margin-right: vw(6);
        }
        &.success {
          color: $color-success;
        }
        &.warn {
          color: $color-warning;
        }
        &.danger {
          color: $color-danger;
        }
        &.primary {
          color: $color-info;
        }
      }
    }
  }
}

::v-deep .el-form-item {
  margin-bottom: 0 !important;

  .el-form-item__label {
    font-weight: 400;
    font-size: vw(14);
    color: #b8c6d3;
    line-height: vh(28);
  }
  .el-form-item__content {
    color: #09b5ff;
    line-height: vh(28);
    text-align: left;
  }
}

::v-deep .el-table {
  thead {
    font-weight: 400;
    font-size: vw(16);
    color: #93e4ff;
    tr {
      background: rgba(27, 123, 214, 0.15);
    }
  }
  tr {
    background: rgba(0, 30, 58, 0.72);
    border: 1px solid rgba(103, 192, 255, 0.46);
  }
}
.tableSpec {
  width: 100%;
  --el-table-border-color: rgba(222, 253, 255, 0.16);
}
.center_bottom .table_box,
.center_bottom .tableSpec {
  background-color: transparent !important;
}
::v-deep .center_bottom .el-table,
::v-deep .center_bottom .el-table__header-wrapper,
::v-deep .center_bottom .el-table__body-wrapper,
::v-deep .center_bottom .el-table__empty-block,
::v-deep .center_bottom .el-table tr,
::v-deep .center_bottom .el-table td,
::v-deep .center_bottom .el-table th {
    background-color: transparent !important;
}
::deep(.el-table) {
  background-color: transparent;
}
::deep(.el-table__expanded-cell) {
  background-color: transparent;
}

::deep(.el-table th) {
  font-weight: 400;
  font-size: vw(14);
  color: #a3c8e8 !important;
  background-color: transparent !important;
  border-top: 1px solid #58bfff;
}
::v-deep .el-table::before {
  background-color: transparent !important;
}

::v-deep .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px dashed #093863 !important;
}
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #58bfff;
}
::v-deep .el-table .el-table__row .el-table__cell .cell {
  color: #fff;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: transparent !important;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

.nothing {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  display: block;
  width: 45%;
  max-width: 320px;
  max-height: 65%;
  height: auto;
  object-fit: contain;
  margin: 0;
  transform: translate(-50%, -50%);
}
</style>
